import type { FC, SVGProps } from 'react';

const Close: FC<SVGProps<SVGSVGElement>> = props => {
    return (
        <svg width={12} height={12} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g fill="none" strokeWidth={2}>
                <path transform="matrix(.72083 .6931 -.72083 .6931 1 2)" d="M0-1h12.985" />
                <path transform="matrix(-.72083 .6931 .72083 .6931 11.5 2)" d="M0-1h12.985" />
            </g>
        </svg>
    );
};

export default Close;
